import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_APPLE_PAY_ENABLED = createFcmConfig('apple_pay_enabled', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
